<template>
	<Page :info="info"/>
</template>
<script>
import Page from '../common/Page'
export default {
	components:{Page},
	data(){
		return {
			info:{
				banner:{
					img:'/static/images/scheme/banner6.jpg',
					title:'建材行业风险解决方案',
					subtitle:'我们针对于建材行业特性，输出定制如下组合方案， <br>供建材行业生产工厂基于企业需求进行投保'
				},
				product:[0,1,7,2,5],
				case:[0,1,6,2]
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/pages/scheme/components/page/Jiancai.vue